import 'babel-polyfill';
import 'whatwg-fetch';

import * as angular from 'angular';

import '../style/core.scss';

import ngFileUpload from 'ng-file-upload';
import uiRouter from 'angular-ui-router';
import 'angularjs-toaster';
import 'html5shiv';
import ngMessages from 'angular-messages';
import bootstrapDatepicker from 'bootstrap-datepicker';
import 'angular-password';
import 'angular-modal-service';
import 'ui-select';
import angularLoadingBar from 'angular-loading-bar';

import registerAdminModule from './admin';
import registerCommonModule from './common';
import registerDataImportExportModule from './data-import-export';
import registerDealearModule from './dealer';
import registerLetterAndCommunicationModule from './letter-communication';
import registerReportModule from './report';
import registerTasksModule from './tasks';
import registerSink from './sink';
import registerAccountModule from './account';
import registerAccountGroupsModule from './accountGroups';
import registerMiReportsModule from './mireports';

const vmcApp = angular.module('vmcApp', [
    uiRouter,
    ngFileUpload,
    'toaster',
    ngMessages,
    bootstrapDatepicker,
    'ngPassword',
    'angularModalService',
    'ui.select',
    angularLoadingBar
]);

registerAdminModule(vmcApp);
registerCommonModule(vmcApp);
registerDataImportExportModule(vmcApp);
registerDealearModule(vmcApp);
registerLetterAndCommunicationModule(vmcApp);
registerReportModule(vmcApp);
registerTasksModule(vmcApp);
registerAccountModule(vmcApp);
registerAccountGroupsModule(vmcApp);
registerMiReportsModule(vmcApp);

if (ENV !== 'production') {
    registerSink(vmcApp);
}

vmcApp.config(($locationProvider, $urlRouterProvider) => {
    $locationProvider.hashPrefix('');
    $urlRouterProvider.otherwise('/');
});



// WEBPACK FOOTER //
// ./Client/app/index.js